import React from 'react';
// import PropTypes from 'prop-types';
import MuiBtn from '@material-ui/core/Button';

const LinkButton = ({ children, ...others }) => (
  <MuiBtn {...others}>{children}</MuiBtn>
);

export default LinkButton;
